import React from 'react';

export function Legal() {
  return (
    <div className="space-y-4">
      <div className="bg-primary rounded-lg p-4 text-center">
        <h1 className="text-xl font-semibold text-white">AVISO LEGAL</h1>
      </div>

      <div className="bg-white rounded-lg shadow-md p-6">
        <div className="space-y-6">
          <div className="space-y-2">
            <p><strong>Titular:</strong> Sandra Palacios Herrero</p>
            <p><strong>NIF:</strong> 48310009G</p>
            <p><strong>Domicilio Fiscal:</strong> Paterna, Valencia, España</p>
            <p><strong>Correo Electrónico:</strong> sanpahe79@gmail.com</p>
            <p><strong>Actividad:</strong> Gabinete de estética y quiromasaje en Paterna exclusivo para mujeres.</p>
          </div>

          <div className="space-y-4">
            <h2 className="text-lg font-semibold text-primary">1. Información General</h2>
            <p className="text-gray-700">
              En cumplimiento de lo establecido en la Ley 34/2002, de 11 de julio, de Servicios de la Sociedad de la Información y del Comercio Electrónico (LSSI-CE), así como en otras normativas aplicables, se informa a los usuarios de la aplicación móvil "Sandra" sobre los siguientes aspectos legales:
            </p>
            <div className="pl-4">
              <p><strong>Denominación Social:</strong> Sandra Palacios Herrero</p>
              <p><strong>NIF:</strong> 48310009G</p>
              <p><strong>Domicilio:</strong> Paterna, Valencia, España</p>
              <p><strong>Correo Electrónico de Contacto:</strong> sanpahe79@gmail.com</p>
            </div>
          </div>

          <div className="space-y-4">
            <h2 className="text-lg font-semibold text-primary">2. Objeto de la Aplicación</h2>
            <p className="text-gray-700">
              La aplicación "Sandra" tiene como finalidad proporcionar información detallada sobre los servicios de estética y quiromasaje ofrecidos por Sandra Palacios Herrero, dirigidos exclusivamente a mujeres en Paterna.
            </p>
          </div>

          <div className="space-y-4">
            <h2 className="text-lg font-semibold text-primary">3. Condiciones de Uso</h2>
            <p className="text-gray-700">
              El acceso y uso de la aplicación "Sandra" se rige por las presentes condiciones:
            </p>
            <div className="space-y-2 pl-4">
              <p><strong>Uso Adecuado:</strong> El usuario se compromete a utilizar la aplicación de manera lícita y adecuada, absteniéndose de realizar actividades que puedan dañar la imagen, intereses o derechos de Sandra Palacios Herrero o de terceros.</p>
              <p><strong>Exactitud de la Información:</strong> Aunque se procura que la información proporcionada en la aplicación sea precisa y actualizada, Sandra Palacios Herrero no garantiza la exactitud, veracidad o vigencia de los contenidos, pudiendo realizar modificaciones sin previo aviso.</p>
            </div>
          </div>

          <div className="space-y-4">
            <h2 className="text-lg font-semibold text-primary">4. Propiedad Intelectual e Industrial</h2>
            <p className="text-gray-700">
              Todos los contenidos de la aplicación, incluyendo textos, imágenes, diseños, logotipos, marcas y cualquier otro material susceptible de protección, están protegidos por los derechos de propiedad intelectual e industrial correspondientes. Queda prohibida su reproducción, distribución, comunicación pública o transformación sin la autorización expresa de Sandra Palacios Herrero.
            </p>
          </div>

          <div className="space-y-4">
            <h2 className="text-lg font-semibold text-primary">5. Responsabilidad</h2>
            <div className="space-y-2 pl-4">
              <p><strong>Disponibilidad del Servicio:</strong> Sandra Palacios Herrero no garantiza la disponibilidad continua de la aplicación, pudiendo interrumpir su acceso por razones técnicas, de seguridad o mantenimiento.</p>
              <p><strong>Exclusión de Responsabilidad:</strong> No se responsabiliza de los daños o perjuicios que pudieran derivarse del uso inadecuado de la aplicación por parte de los usuarios.</p>
            </div>
          </div>

          <div className="space-y-4">
            <h2 className="text-lg font-semibold text-primary">6. Legislación Aplicable y Jurisdicción</h2>
            <p className="text-gray-700">
              Las presentes condiciones se rigen por la legislación española. Para cualquier controversia que pudiera surgir en relación con la aplicación o sus contenidos, las partes se someten a los juzgados y tribunales competentes de Valencia, España.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}